/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Land_UnlockedInputs */

const en_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Land Style Unlocked!`)
};

const ar_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم فتح نمط أرض جديد!`)
};

const de_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Land-Stil freigeschaltet!`)
};

const es_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Nuevo estilo de terreno desbloqueado!`)
};

const fr_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau style de sol débloqué !`)
};

const it_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo stile del terreno sbloccato!`)
};

const ja_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいランドスタイルをアンロック！`)
};

const ko_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 랜드 스타일 잠금 해제!`)
};

const pt_br_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo estilo de terreno desbloqueado!`)
};

const ru_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокирован новый стиль земли!`)
};

const th_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกสไตล์พื้นดินใหม่แล้ว!`)
};

const tr_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni arazi türünün kilidi açıldı!`)
};

const zh_cn_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁新土地皮肤！`)
};

const zh_tw_new_land_unlocked = /** @type {(inputs: New_Land_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解鎖新土地造型！`)
};

/**
* | output |
* | --- |
* | "New Land Style Unlocked!" |
*
* @param {New_Land_UnlockedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const new_land_unlocked = /** @type {((inputs?: New_Land_UnlockedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Land_UnlockedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_land_unlocked(inputs)
	if (locale === "ar") return ar_new_land_unlocked(inputs)
	if (locale === "de") return de_new_land_unlocked(inputs)
	if (locale === "es") return es_new_land_unlocked(inputs)
	if (locale === "fr") return fr_new_land_unlocked(inputs)
	if (locale === "it") return it_new_land_unlocked(inputs)
	if (locale === "ja") return ja_new_land_unlocked(inputs)
	if (locale === "ko") return ko_new_land_unlocked(inputs)
	if (locale === "pt_br") return pt_br_new_land_unlocked(inputs)
	if (locale === "ru") return ru_new_land_unlocked(inputs)
	if (locale === "th") return th_new_land_unlocked(inputs)
	if (locale === "tr") return tr_new_land_unlocked(inputs)
	if (locale === "zh_cn") return zh_cn_new_land_unlocked(inputs)
	return zh_tw_new_land_unlocked(inputs)
});